import client from "../../client";
import clientAuth from "../../clientAuth"
export default {
    // index: (page=1,searchQuery = '',sortConfig ='') => clientAuth.get(`admin/scraped-product-prices/index?page=${page}${sortConfig}${searchQuery}`),
    index: (payload) => {
        return clientAuth.post("admin/scraped-product-prices/index", {
            json: payload,
        });
    },
    bulkupdate: (id, userData) => clientAuth.put(`admin/price/bulkupdate/${id}`, { json: userData }),
    bulkapprove: (id) => clientAuth.put(`admin/scraped-product-prices/bulkapprove/${id}`),
    accessField: () => clientAuth.get(`admin/scraped-product-prices/access-fields`),
    manageAccessFields:(userData) =>  clientAuth.post(`admin/scraped-product-prices/manage-access-fields`,{ json: userData }),
    bulkupdate: (id, userData) => clientAuth.put(`admin/scraped-product-prices/bulkupdate/${id}`, { json: userData }),
    bulkdestroy: (id) => clientAuth.delete(`admin/scraped-product-prices/bulkdestroy/${id}`),
    destroy: (id) => clientAuth.delete(`admin/scraped-product-prices/destroy/${id}`),

};